/**
 * One home for „orders a truck no longer takes” (review LOW, round 3): the
 * order picker of the transport form and the „Dołóż zamówienie” candidates
 * hide ZK/ZD in these statuses (RECEIVED: a ZD already in the warehouse).
 */
export const CLOSED_ORDER_STATUSES: ReadonlySet<string> = new Set(['CANCELLED', 'COMPLETED', 'DELIVERED', 'RECEIVED']);

export function isClosedOrderStatus(status: unknown): boolean {
  return CLOSED_ORDER_STATUSES.has(String(status || ''));
}
